import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'jalali-moment';
@Pipe({
  name: 'persianDate'
})
export class PersianDatePipe implements PipeTransform {
  dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
  dateTimeOptions = { hour: 'numeric', minute: 'numeric', second: 'numeric' };

  transform(value: any, args?: any): any {
    if (!value || value === null) {
      return '';
    }
    if (args === 'dateTime') {
      return moment(value.toString()).format('jYYYY/jMM/jDD HH:mm:ss');
    }
    // date
    return moment(value.toString()).format('jYYYY/jMM/jDD');
  }
}
